<template>
  <div class="landing">

      <v-layout class="first flex-grow-1">
          <v-container>
                <v-row align="center" justify="center" class="notfound">
                  <v-col class="wrap" cols="9" xl="8" md="12" lg="11" sm="12" offset-xl="1">
                    <p>Diese Seite konnnte leider nicht gefunden werden.</p>
                    <p>
                      <router-link
                      :to="'/'+$home"
                      >Zurück zur Startseite.
                      </router-link>
                    </p>
                  </v-col>
                </v-row>
          </v-container>
      </v-layout>

      <v-layout class="iblue">
          <v-container>
                <v-row align="center">                    
                    <v-col class="wrap" cols="9" xl="8" md="12" lg="11" sm="12" offset-xl="1">
                      <Contact></Contact>
                    </v-col>
                </v-row>
          </v-container>
      </v-layout>

      <Footer></Footer>

  </div>

</template>

<script>

import Contact from '../components/elements/Contact';
import Footer from './elements/Footer';

export default {
  name: 'PageNotFound',

  components: {
    Contact,
    Footer
  },
  props: {    
    template: String
  },  
  data() {
    return {
      host: window.location.host,
      contacts: null
    }
  },
  methods: {
  }
};
</script>

<style scoped>
.landing {
  height:100%;
  background-color: #ffffff;
}
</style>
<style>
.layout.first {
  padding-top:60px;
  padding-bottom:20px;
}
.container {
  background-color:transparent;
  max-width:1560px;
}
</style>
